<template>
  <div class="faculdade_imagem">
    <img :src="faculdadeImagem" />
    <div
      class="img_faculdade_mobile"
      :style="{ backgroundImage: `url('${faculdadeImagem}')` }"
    ></div>
    <div class="faculdade_camada2"></div>
    <div class="faculdade_titulo">
      <Transition name="slide-fade">
        <h1 v-if="show">
          {{ tipoFaculdade }}
        </h1>
      </Transition>
      <Transition name="slide-fade">
        <h2 v-if="show" :class="$store.state.faculdadename">
          {{ faculdade?.nomecurto }}
          <span
            class="faculdade_titulo_linha"
            :class="$store.state.faculdadename"
          ></span>
        </h2>
      </Transition>
    </div>
    <img
      v-if="$store.state.faculdadename == 'escolasuperiordesaude'"
      class="faculdade_logo"
      src="@/assets/ess_logotipo.jpg"
    />
    <HeaderBreadcrumb></HeaderBreadcrumb>
  </div>
</template>

<script>
import HeaderBreadcrumb from "../../components/HeaderBreadcrumb.vue";

export default {
  name: "FaculdadeHeader",
  inject: ["i18n", "language"],
  components: {
    HeaderBreadcrumb,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    tipoFaculdade() {
      if (this.$store.state.faculdade?.tipo == "faculdade") {
        return this.$translate("UMA_LANG_TIPOFACULDADE");
      } else {
        return this.$translate("UMA_LANG_TIPOESCOLA");
      }
    },
    faculdade() {
      return this.$store.state.faculdade;
    },
    faculdadeImagem() {
      return this.$store.state.faculdade?.imagem;
    },
  },
  mounted() {
    this.show = true;
  },
};
</script>

<style scoped lang="scss">
@import "../../global";
.slide-fade-enter-active {
  opacity: 1;
  transition-property: opacity, transform;
  transition-duration: 0.8s, 1s;
  transition-timing-function: ease-in, ease-in;
  transition-delay: 0.2s, 0.2s;
  transform: translate3D(0, 0px, 0);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translate3D(0, -20px, 0);
}

.faculdade_titulo_linha {
  height: 3px;
  display: block;
  z-index: 3;
  margin: 0 auto;
}

.faculdade_titulo_linha.artesehumanidades {
  background: $ahline;
}

.faculdade_titulo_linha.cienciasexatasedaengenharia {
  background: $ceeline;
}

.faculdade_titulo_linha.cienciassociais {
  background: $csline;
}

.faculdade_titulo_linha.cienciasdavida {
  background: $cvhline;
}

.faculdade_titulo_linha.escolasuperiordetecnologiasegestao {
  background: $tghline;
}

.faculdade_titulo_linha.escolasuperiordesaude {
  background: $ssline;
}

.faculdade_titulo h2.artesehumanidades {
  border-color: $ahline;
}

.faculdade_titulo h2.cienciasexatasedaengenharia {
  border-color: $ceeline;
}

.faculdade_titulo h2.cienciassociais {
  border-color: $csline;
}

.faculdade_titulo h2.cienciasdavida {
  border-color: $cvhline;
}

.faculdade_titulo h2.escolasuperiordetecnologiasegestao {
  border-color: $tghline;
}

.faculdade_titulo h2.escolasuperiordesaude {
  border-color: $ssline;
}

/*16-27*/
.faculdade_camada2 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: repeating-linear-gradient(
    -40deg,
    #12171d,
    #12051d 1px,
    #12051d 1px,
    #12171d 4px
  );
  opacity: 0.5;
  z-index: 1;
}

.faculdade_camada2.nogradient {
  background: linear-gradient(
    -40deg,
    #12171d,
    #12051d 1px,
    #12051d 1px,
    #12171d 4px
  );
}

/*268*/
.faculdade_imagem {
  position: relative;
  max-height: 670px;
  overflow-y: hidden;
}

/*274-301*/
.faculdade_titulo {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 30%;
  text-align: center;
  z-index: 3;
}

.faculdade_titulo h1 {
  font-family: "PT Sans Bold Italic";
  color: white;
  z-index: 3;
  text-transform: capitalize;
}

.faculdade_titulo h2 {
  font-family: "Montserrat Bold";
  color: white;
  font-size: 60px;
  text-transform: uppercase;
  margin-bottom: 0px;
  z-index: 3;
  white-space: nowrap;
  display: inline-block;
}

.faculdade_titulo_linha {
  height: 3px;
  display: block;
  z-index: 3;
  margin: 0 auto;
}

/*976*/
.img_faculdade_mobile {
  display: none;
}

.faculdade_logo {
  position: absolute;
  bottom: 20px;
  left: 40px;
  width: 200px;
}

@media only screen and (max-width: 1439px) {
  /*1018*/
  .faculdade_titulo h2 {
    font-size: 50px;
  }
  /*1022*/
  .faculdade_titulo h1 {
    font-size: 43px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  /*1103*/
  .faculdade_imagem img {
    display: none;
  }

  /*1237*/
  .img_faculdade_mobile {
    display: block;
    height: 520px;
    background-size: cover;
    background-position: center;
  }

  /*1244-1266*/
  .faculdade_titulo h2 {
    font-size: 46px !important;
    white-space: normal;
    border: 3px solid;
    padding-bottom: 30px;
    padding-top: 30px;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  .faculdade_titulo span {
    display: none;
  }

  .faculdade_titulo {
    top: 18%;
  }

  .faculdade_titulo h1 {
    font-size: 37px;
  }

  .faculdade_titulo {
    width: 78%;
  }
  /*
  .faculdade_imagem img.faculdade_logo {
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    bottom: 115px;
  }
*/
}

@media (max-width: 767px) {
  /*1448*/
  .faculdade_imagem img {
    display: none;
  }
  /*1617*/
  .img_faculdade_mobile {
    display: block;
    height: 280px;
    background-size: cover;
    background-position: center;
  }

  /*1625-1650*/
  .faculdade_titulo h2 {
    font-size: 20px !important;
    white-space: normal;
    border: 1.5px solid;
    padding-bottom: 20px;
    padding-top: 16px;
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 42px;
    margin-left: 42px;
    font-family: "Montserrat Semibold";
  }

  .faculdade_titulo h1 {
    font-size: 21px;
    font-family: "PT Sans Italic";
  }

  .faculdade_titulo span {
    display: none;
  }

  .faculdade_titulo {
    top: 24%;
  }

  .faculdade_titulo {
    width: 100%;
  }
  /*
  .faculdade_imagem img.faculdade_logo {
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    bottom: 18px;
    width: 170px;
  }
  */
}
</style>